<div class="flex-row align-items-center py-8">
	<mat-menu #actionsMenu="matMenu">
		<button mat-menu-item
				(click)="contentBlockUpdated.emit()">
			<mat-icon>edit</mat-icon>
			Edit Content Block
		</button>
		<button mat-menu-item
				(click)="contentBlockDeleted.emit()">
			<mat-icon>delete</mat-icon>
			Remove Content Block
		</button>
	</mat-menu>

    <mat-radio-button class="flex-grow-1"
                      [value]="contentBlock().title"
                      [checked]="contentBlock().selected"
                      (change)="contentBlockSelected.emit()">
        <div class="ml-8">
			<div>{{ contentBlock().title }}</div>
			@if (contentBlock().description) {
				<div class="text-muted">{{ contentBlock().description }}</div>
			}
		</div>
    </mat-radio-button>

	<button mat-icon-button
			[matMenuTriggerFor]="actionsMenu">
		<mat-icon>more_vert</mat-icon>
	</button>
</div>
